var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 54,
    viewBox: "0 0 94 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5229 52.2943C89.6898 53.3862 90.7101 54.1362 91.802 53.9694C92.8939 53.8026 93.6439 52.7822 93.4771 51.6903L89.5229 52.2943ZM0.0437528 19.5789C-0.186025 20.6593 0.503546 21.7214 1.58395 21.9512L19.1902 25.6956C20.2706 25.9254 21.3327 25.2358 21.5625 24.1554C21.7922 23.075 21.1027 22.0129 20.0223 21.7831L4.3723 18.4547L7.70069 2.80475C7.93047 1.72434 7.24089 0.662231 6.16049 0.432454C5.08008 0.202677 4.01797 0.892247 3.78819 1.97265L0.0437528 19.5789ZM93.4771 51.6903C87.7229 14.0249 40.4298 -7.33991 0.910915 18.3175L3.08908 21.6724C40.5702 -2.662 84.2771 17.9565 89.5229 52.2943L93.4771 51.6903Z",
    fill: "#192830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.f6592da63219545a9165450a2567fd71.svg";
export { ForwardRef as ReactComponent };